import React, { useEffect, useState } from "react";
import axios from "axios";
import Layout from "../../components/Layout/layout";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../axiosInstance";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import "react-toastify/dist/ReactToastify.css";
import { parse } from "json2csv";
import moment from "moment";

const MainAdminPanel = ({ admin, setAdmin }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [user, setUser] = useState(null);

  const openModal = (user) => {
    setUser(user);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setUser(null);
  };

  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!admin) {
      navigate("/adminLogin");
    }
  }, [admin, navigate]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(`${baseURL}/user/admin/getUsers`, {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        });
        setUsers(response.data);
        // console.log(users);
      } catch (error) {
        setError("Failed to fetch users");
        toast.error("Failed to fetch users");
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  // console.log(user);

  const updatePaymentStatus = async (userId, currentStatus) => {
    try {
      const response = await axios.put(
        `${baseURL}/user/admin/updateUser/${userId}`,
        {
          isPaymentSuccessFul: !currentStatus,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      setUsers(
        users.map((user) =>
          user._id === userId
            ? { ...user, isPaymentSuccessFul: !currentStatus }
            : user
        )
      );
      toast.success("Payment status updated successfully");
    } catch (error) {
      toast.error("Failed to update payment status");
    }
  };

  const sendEmail = async (
    userId,
    userEmail,
    firstName,
    middleName,
    lastName,
    title
  ) => {
    try {
      const response = await axios.post(
        `${baseURL}/user/admin/sendEmail`,
        {
          userId: userId,
          email: userEmail,
          firstName: firstName,
          middleName: middleName,
          lastName: lastName,
          title: title,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );

      await axios.put(
        `${baseURL}/user/admin/updateUser/${userId}`,
        {
          isEmailSent: true,
        },
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      setUsers(
        users.map((user) =>
          user._id === userId ? { ...user, isEmailSent: true } : user
        )
      );
      toast.success("Email sent successfully");
    } catch (error) {
      console.log(error);
      toast.error("Failed to send email ");
    }
  };
  const downloadCSV = (next) => {
    const fields = [
      "updatedAt",
      "_id",
      "title",
      "name.first",
      "name.middle",
      "name.last",
      "email",
      "contact",
      "institution",
      "designation",
      "foodPreference",
      "registrationCategory",
      "transactionId",
      "isPaymentSuccessFul",
      "registrationCategory",
      "studentIdCopy",
      "paperId",
    ];
    const opts = { fields };

    try {
      // Parse the users array into CSV format
      const csv = parse(users, opts);

      // Create a Blob from the CSV string
      const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

      // Create a link element to download the CSV file
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.href = url;
      link.setAttribute("download", "users.csv");

      // Append the link to the body, click it, and remove it
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Release the object URL
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      // Display an error message using toast (assuming you have a toast library)
      toast.error("Failed to download CSV");
      next();
    }
  };
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return (
      <Layout>
        <div className="bg-[#D7DDE1] py-10 ">
          <div className="w-full md:w-3/4 px-10 md:px-20 py-8 border-2 bg-[#f5f4f4] z-20 mb-[5vh] relative mx-auto">
            <div>{error}</div>
          </div>
        </div>
      </Layout>
    );
  }

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredUsers = users.filter((user) =>
    user._id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Layout>
      <div className="bg-[#D7DDE1] py-10">
        <div className="w-full md:w-4/4 px-10 md:px-20 py-8 border-2 bg-[#f5f4f4] z-20 mb-[5vh] relative mx-auto">
          <div className="font-bold text-4xl text-[#1F7E95] mb-10">
            Admin Panel
          </div>

          <div className="text-lg mb-10 text-gray-500">
            Handle Changes for User
          </div>

          <div className="w-full mt-[3rem] ">
            {/* <ToastContainer style={{ marginTop: "50px" }} /> */}
            {admin && (
              <div className=" text-black">
                <div className="w-full flex justify-between">
                  <h2 className="text-2xl font-bold mb-4">All Users</h2>
                  <input
                    type="search"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    placeholder="Search by Registration ID"
                    className="border p-2 rounded mb-4 w-[20rem]"
                  />
                  <button
                    className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded mb-4"
                    onClick={downloadCSV}
                  >
                    Download CSV
                  </button>
                </div>
                <div className="overflow-scroll">
                  <table className="w-full table-auto ">
                    <thead>
                      <tr>
                        <th className="px-4 py-2">S.No.</th>
                        <th className="px-4 py-2">Registration ID</th>
                        <th className="px-4 py-2">Title</th>
                        <th className="px-4 py-2">Name</th>
                        <th className="px-4 py-2">Email</th>
                        <th className="px-4 py-2">Institution</th>
                        <th className="px-4 py-2">Designation</th>
                        <th className="px-4 py-2 ">Transaction ID</th>
                        <th className="px-4 py-2">Category</th>
                        <th className="px-4 py-2">Student ID</th>
                        <th className="px-4 py-2">Paper ID</th>
                        <th className="px-4 py-2">Payment Status</th>
                        <th className="px-4 py-2">Email Status</th>
                        <th className="px-4 py-2">Date & Time of Reg.</th>
                        <th className="px-4 py-2">Action</th>
                        <th className="px-4 py-2">Receipt-Image Link</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredUsers.map((user, index) => (
                        <tr key={user._id}>
                          <td className="border px-4 py-2">{index + 1}</td>
                          <td className="border px-4 py-2">{user._id}</td>
                          <td className="border px-4 py-2">{user.title}</td>
                          <td className="border px-4 py-2">{`${user.name.first} ${user.name.middle} ${user.name.last}`}</td>
                          <td className="border px-4 py-2">{user.email}</td>
                          <td className="border px-4 py-2">
                            {user.institution}
                          </td>
                          <td className="border px-4 py-2">
                            {user.designation}
                          </td>
                          <td className="border px-4 py-2">
                            {user.transactionId}
                          </td>
                          <td className="border px-4 py-2">
                            {user.registrationCategory}
                          </td>
                          <td className="border px-4 py-2">
                            {user.studentIdCopy}
                          </td>
                          <td className="border px-4 py-2">{user.paperId}</td>
                          <td className="border px-4 py-2">
                            {user.isPaymentSuccessFul
                              ? "Successful"
                              : "Confirmation Pending"}
                          </td>
                          <td className="border px-4 py-2">
                            {user.isEmailSent ? "Email Sent" : "Email not sent"}
                          </td>
                          <td className="border px-4 py-2">
                            {moment(user.createdAt).format(
                              "MMMM Do YYYY, h:mm:ss a"
                            )}
                          </td>
                          <td className="border px-4 py-2">
                            <button
                              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                              onClick={() => openModal(user)}
                            >
                              Details
                            </button>
                          </td>
                          <td className="">
                            <a
                              target="_blank"
                              href={`${baseURL}/${user.paymentreceipt.replace(
                                "assets/",
                                ""
                              )}`}
                            >
                              Link
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {isModalOpen && user && (
        <div className="fixed inset-0 flex items-center justify-center z-50">
          <ToastContainer style={{ marginTop: "50px" }} />
          <div
            className="absolute inset-0 bg-black opacity-50"
            onClick={closeModal}
          ></div>
          <div className="bg-white p-8 rounded shadow-lg relative z-10 w-[50%] ">
            <div className="flex justify-between items-center">
              <div></div>
              <button
                className=" hover:bg-red-500 text-black hover:text-white font-semibold px-1 rounded transition-all"
                onClick={closeModal}
              >
                X
              </button>
            </div>
            <h2 className="text-2xl mb-4">User Details</h2>
            <div className="w-full flex justify-between items-center">
              <div>
                <p>
                  <strong>Registration ID:</strong> {user._id}
                </p>
                <p>
                  <strong>Name:</strong>
                  {`${user.name.first} ${user.name.middle} ${user.name.last}`}
                </p>
                <p>
                  <strong>Email:</strong> {user.email}
                </p>
                <p>
                  <strong>Institution:</strong> {user.institution}
                </p>
                <p>
                  <strong>Designation:</strong> {user.designation}
                </p>
                <p>
                  <strong>Billing Address:</strong> {user.billingAddress}
                </p>
                <p>
                  <strong>Food Preference:</strong> {user.foodPreference}
                </p>
                <p>
                  <strong>Registration Category:</strong>
                  {user.registrationCategory}
                </p>
                <p>
                  <strong>Paper ID:</strong>
                  {user.paperId}
                </p>
                <p>
                  <strong>Payment Status:</strong>
                  {user.isPaymentSuccessFul
                    ? "Successful"
                    : "Confirmation Pending"}
                </p>
                <p>
                  <strong>TransactionID:</strong> {user.transactionId}
                </p>
                <p>
                  <strong>Date & Time:</strong>{" "}
                  {moment(user.createdAt).format("MMMM Do YYYY, h:mm:ss a")}
                </p>
                {user.accompanyPersonId && (
                  <p>
                    <strong>Accompany Person ID:</strong>
                    {user.accompanyPersonId}
                  </p>
                )}
                {user.studentIdCopy && (
                  <p>
                    <strong>Student ID:</strong> {user.studentIdCopy}
                  </p>
                )}
              </div>
              <div>
                <img
                  src={`${baseURL}/${user.qrCode.replace("uploads/", "")}`}
                  alt=""
                  className="w-100 h-100 "
                />
              </div>
            </div>
            <div className="mt-4">
              <button
                className="bg-green-500 hover:bg-green-700 text-white font-bold py-2 px-4 rounded mr-2"
                onClick={() =>
                  updatePaymentStatus(user._id, user.isPaymentSuccessFul)
                }
              >
                {user.isPaymentSuccessFul
                  ? "Marked Successful"
                  : "Mark as Successful"}
              </button>
              <button
                className={`bg-blue-500  text-white font-bold py-2 px-4 rounded mr-2 ${
                  user.isEmailSent ? "cursor-not-allowed" : "hover:bg-blue-700"
                }`}
                onClick={() =>
                  sendEmail(
                    user._id,
                    user.email,
                    user.name.first,
                    user?.name?.middle,
                    user.name.last,
                    user.title
                  )
                }
                disabled={user.isEmailSent}
              >
                {user.isEmailSent ? "Email Sent" : "Send Email"}
              </button>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default MainAdminPanel;
